export default __webpack_public_path__ + "static/media/ci-segment-total.dd916f5b.svg";